/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { detailPageData } from "../../../data";

import "./Details.scss";

import NotFound from "../Error/404";

import Navbar from "../../templates/Navbar/Navbar";
import Footer from "../../templates/Footer/Footer";
import Header from "../../templates/CoursesPage/Header/Header";
import Public from "../../templates/Public/Public";
import Teachers from "../../templates/CoursesPage/Teachers/Teachers";
import Advantages from "../../templates/CoursesPage/Advantages/Advantages";
import Questions from "../../templates/CoursesPage/Questions/Questions";
import Partners from "../../templates/CoursesPage/Partners/Partners";
import Assurance from "../../templates/CoursesPage/Assurance/Assurance";
import Courses from "../../templates/Courses/Courses";
import ColHeader from "../../templates/CoursesPage/ColHeader/Header";
import Reviews from "../../templates/CoursesPage/Reviews/Reviews";
import TabLayout from "../../templates/CoursesPage/TabLayout/TabLayout";

import { normalizeTitle, renderModules } from "./utils";
import CardsList from "../../templates/CoursesPage/CardsList/CardsList";

const Details = ({ type }: { type: string }) => {
  const { id } = useParams();
  const [detail, setDetail] = React.useState(
    detailPageData("pt", `${type}/${id}`),
  );

  useEffect(() => {
    if (
      id === "imersao-acesso-vascular-para-hemodialise-e-hdf" ||
      id === "simposio-de-nefrologia"
    )
      window.location.href = "../catalogo";
  }, []);

  useEffect(() => {
    const titleClass = normalizeTitle(detail?.header?.title?.title || "");

    document.querySelector("body")?.classList.add(`details-page`);
    document.querySelector("body")?.classList.add(`${type}`);
    document.querySelector("body")?.classList.add(`${titleClass}`);

    if (detail?.header) {
      document.title = `${detail.header.title.title} || Instituto Valquiria Arenas`;
    }
  }, [detail]);

  useEffect(() => {
    setDetail(detailPageData("pt", `${type}/${id}`));
  }, [id]);

  if (detail)
    return (
      <>
        <Navbar />
        {detail.header && detail.header.type === "column" ? (
          <ColHeader data={detail.header} nameBlock="header" />
        ) : (
          <Header data={detail.header} nameBlock="header" />
        )}
        {detail.advantagesRow && <Advantages data={detail.advantagesRow} />}
        {detail.reviewsTop && (
          <Reviews data={detail.reviewsTop} position="top" />
        )}
        {detail.about && (
          <section
            id="about"
            className="about__content detail"
            dangerouslySetInnerHTML={{ __html: `${detail.about}` }}
          ></section>
        )}
        {detail.location && detail.location.tabLayout && (
          <TabLayout data={detail.location.tabLayout} />
        )}
        {detail.public && <Public data={detail.public} />}
        {renderModules(detail.modules)}
        {detail.commertialText && (
          <section
            id="commertialText"
            className="commertialText__content detail"
            dangerouslySetInnerHTML={{ __html: `${detail.commertialText}` }}
          />
        )}
        {renderModules(detail.modules2)}
        {detail.reviewsMiddle && (
          <Reviews data={detail.reviewsMiddle} position="middle" />
        )}
        {renderModules(detail.bonus, { styleClass: "bonus" })}
        {detail.reviewsBottom && (
          <Reviews data={detail.reviewsBottom} position="middle" />
        )}
        {detail.teachers && <Teachers data={detail.teachers} />}
        {detail.collaborators && <CardsList data={detail.collaborators} />}
        {detail.coordination && <CardsList data={detail.coordination} />}
        {detail.publishers && <CardsList data={detail.publishers} />}
        {detail.offer && <Header data={detail.offer} nameBlock="offer" />}
        {detail.assurance && <Assurance data={detail.assurance} />}
        {detail.partners && <Partners list={detail.partners} type="partners" />}
        {detail.helpers && <Partners list={detail.helpers} type="helpers" />}
        {detail?.courses?.show && (
          <Courses slick={detail?.courses?.slick} type="courses" />
        )}
        {detail.questions && (
          <Questions questions={detail.questions} flag={detail.flag} />
        )}
        {detail?.events?.show && (
          <Courses slick={detail?.events?.slick} type="events" />
        )}
        {detail?.books?.show && (
          <Courses slick={detail?.books?.slick} type="books" />
        )}
        <Footer />
      </>
    );
  else
    return (
      <>
        <NotFound />
      </>
    );
};

export default Details;
